import { pluck, Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { NoContent, StatusResp } from '../api-core/api-core.types';
import { apiDelete, apiGet, apiPost } from '../api-core/api-request';
import apiRequestHookFactory from '../api-core/utility-factories/api-request-hook-factory';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import { apiRedux } from '../api-redux';
import {
  PaymentMethod,
  PaymentMethodResp,
} from '../repairer/api-repairer.types';
import {
  DeliveryLocations,
  HistoryData,
  RepairerInfo,
  SetProfileImgReq,
  UserProfile,
  UserProfileUpdateReq,
} from './api-user.types';

export const useUserProfile = apiResourceHookFactory(
  apiRedux.userProfile,
  () => apiGet<[UserProfile]>(ApiUrl.USER_PROFILE).pipe(pluck(0))
);

export const useUpdateUserProfile = apiRequestHookFactory(
  apiRedux.setUserProfile,
  (data: Partial<UserProfileUpdateReq>) =>
    apiPost<StatusResp>(ApiUrl.USER_PROFILE_UPDATE, data)
);

export const useUpdateUserProfileImg = apiRequestHookFactory(
  apiRedux.setUserProfileImg,
  (data: SetProfileImgReq) =>
    apiPost<StatusResp>(ApiUrl.USER_PROFILE_IMG_SET, data)
);

export const useDeleteUser = apiRequestHookFactory(
  apiRedux.deleteUser,
  () => apiDelete<StatusResp>(ApiUrl.USER_DELETE)
);

export const useCreatePaymentMethod = apiRequestHookFactory(
  apiRedux.setPaymentMethod,
  (data: PaymentMethod) =>
    apiPost<StatusResp>(ApiUrl.USER_ADD_CREDIT_CARD, data)
);

export const useGetPaymentMethod = apiResourceHookFactory(
  apiRedux.getPaymentMethod,
  () => apiGet<PaymentMethodResp>(ApiUrl.USER_ADD_CREDIT_CARD)
);

export const useDeletePaymentMethod = apiRequestHookFactory(
  apiRedux.deletePaymentMethod,
  (id: string): Observable<NoContent> =>
    apiDelete<NoContent>(`${ApiUrl.USER_CARD_DELETE}/${id}`)
);

export const useGetAddresses = apiResourceHookFactory(
  apiRedux.getAddresses,
  () => apiGet<[DeliveryLocations]>(ApiUrl.USER_ADD_ADDRESSES)
);

export const useAddAddress = apiRequestHookFactory(
  apiRedux.setAddress,
  (data: Partial<DeliveryLocations>) =>
    apiPost<StatusResp>(ApiUrl.USER_ADD_ADDRESSES, data)
);

export const useGetTransactionHistory = apiResourceHookFactory(
  apiRedux.getTransactionHistory,
  () => apiGet<HistoryData[]>(ApiUrl.USER_HISTORY)
);

export const useGetTransactionDetail = apiResourceHookFactory(
  apiRedux.getConsumerTransaction,
  (id: number) =>
    apiGet<HistoryData[]>(`${ApiUrl.USER_HISTORY}/${id}`)
);

export const useGetRepairerInfo = apiResourceHookFactory(
  apiRedux.getRepairerInfo,
  (id: number) =>
    apiGet<RepairerInfo>(`${ApiUrl.REPAIRER_INFO}/${id}`)
);

export const useDeleteChat = apiRequestHookFactory(
  apiRedux.deleteChat,
  (id: number) => apiDelete<StatusResp>(`${ApiUrl.DELETE_CHAT}/${id}`)
);
